import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumScannerType implements BaseEnumType {
  private static allValues: EnumScannerType[] = []; // make sure this is top-most
  
  public static optimus = new EnumScannerType(1, "Optimus", "enum_scanner_type_optimus");
  public static cipherLab8300 = new EnumScannerType(2, "CipherLab8300", "enum_scanner_type_cipher_lab8300");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumScannerType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isOptimus() { return this === EnumScannerType.optimus; }
  public isCipherLab8300() { return this === EnumScannerType.cipherLab8300; }

  public static getValues(): readonly EnumScannerType[] {
    return EnumScannerType.allValues;
  }

  public static getValuesExcept0(): readonly EnumScannerType[] {
    return EnumScannerType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumScannerType {
    const found = EnumScannerType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumScannerType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumScannerType): EnumScannerType {
    const found = name ? EnumScannerType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumScannerType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumScannerType>): boolean {
    return this.key === other?.key;
  }
}